import { advisorHomePath, clientDashboardPath2, clientFilesPath } from 'Consts/Strings';
import { QueryValUrl } from 'Helpers/Query';
import { accountRequestsUri } from 'Consts/advisorUris';
import { balanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';

export const legacyPageRoutes = {
  linkedInstitution: (link, isAgent, collection, history, householdResource) => {
    return balanceSheetPageURL(householdResource, householdResource.id(), isAgent);
  },
  clientDashboard: () => {
    return clientDashboardPath2;
  },
  file: (link, isAgent, collection) => {
    if (isAgent) {
      const res = collection.resources().head();
      window.open(res.link('related').attr('url').href, '_blank', 'noopener,noreferrer');
      return advisorHomePath;
    }

    // Get secureFileID from Link
    const url = new URL(link);
    const secureFileID = QueryValUrl(url, 'secureFileID');
    const folderName = QueryValUrl(url, 'folderName');
    const isFolder = QueryValUrl(url, 'folderName');

    if (isFolder) {
      return `${clientFilesPath}?folderName=${folderName}`;
    }

    // Build route to file viewer
    return `${clientDashboardPath2}?folderName=${folderName}&currentFile=${secureFileID}&files=${secureFileID}&modal=fileViewer`;
  },
  accountCreationRequest: () => {
    return accountRequestsUri;
  },
  user: (_, isAgent) => {
    return isAgent ? advisorHomePath : clientDashboardPath2;
  },
};
